export const B197 = "B197";
export const GQC = "GQC";
export const GQD = "GQD";
